import RecoveredPassword from './RecoveredPassword'

export default RecoveredPassword
